<template>
    <b-card
        class="dashboard-conference-widget"
        v-if="conferenceIn.length"
        no-body>
        <div class="dashboard-conference-header">
            <b-card-img
                class="dashboard-conference-banner"
                :src="conferenceIn.course.image">
            </b-card-img>
            <span class="bg">
                <b-button
                    class="btn-rounded btn-icon btn-play"
                    v-if="conferenceIn.online || conferenceIn.can_create"
                    variant="primary"
                    :class="conferenceIn.online ? 'fa-beat btn-success' : ''"
                    @click="joinConference(conferenceIn.id)">
                    <i class="fa fa-play"></i>
                </b-button>
                <b-button
                    class="btn-rounded btn-icon btn-play"
                    v-else
                    variant="primary"
                    @click="joinConference(conferenceIn.id)">
                    <i class="fa fa-play"></i>
                </b-button>
            </span>
        </div>
        <b-card-body body-class="dashboard-conferences-widget-body">
            <h4 class="conference-title">{{ conferenceIn.title }}</h4>
            <p
                class="conference-date active"
                v-if="conferenceIn.isrunning">
                Nu bezig, duurt tot {{ conferenceIn.shorttimeend }}
            </p>
            <p
                class="conference-date"
                v-else>
                {{ conferenceIn.shortdate }} | {{ conferenceIn.shorttimestart }} - {{ conferenceIn.shorttimeend }}
            </p>
            <p class="conference-name">{{ conferenceIn.course.name }} | {{ conferenceIn.user.full_name }}</p>
            <p class="conference-attendees">{{ conferenceIn.users.length }} {{ $t('conference.participants') }}</p>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: 'design-2021-conference-dashboard-component',
    props: {
        conferenceIn: Array,
    },
    data() {
        return {};
    },
    methods: {
        joinConference(id) {
            this.alert.saving(this.$t('conference.open_lesson_one_moment_please_lesson_will_be_opened'));

            const data = {
                conference_id: id,
            };

            this.axios.post('/conference/join', data).then((response) => {
                if (response.data.error) {
                    this.alert.ajaxError(
                        error,
                        'Les niet beschikbaar',
                        'Het lijkt erop dat deze les helaas niet (meer) bechikbaar is.',
                    );
                } else {
                    window.location.href = response.data.url;
                }
            });
        },
    },
};
</script>

<style scoped lang="scss">
.dashboard-conference-widget:first-of-type {
    margin-top: 16px;
}
.dashboard-conference-header {
    position: relative;
    border: none;
}

.dashboard-conference-header img {
    height: 130px;
    object-fit: cover;
    object-position: center;
}

.bg {
    width: 50px;
    height: 50px;
    border-radius: 50px;
    background: #fff;
    display: block;
    position: absolute;
    bottom: -25px;
    left: calc(50% - 25px);
    box-shadow: 4px 8px 9px -2px #cdccd1;
}

.btn-play {
    top: 4px;
    left: 4px;
    position: relative;
}

.btn-play:hover {
    color: #007bff;
    background-color: #fff;
}

.btn-play.btn-success:hover {
    color: #0acf97;
}

.conference-title {
    text-align: left;
    font-size: 1.3125rem;
    font-weight: 500;
    margin-top: 8px;
}

.conference-date {
    color: #757575;
}

.conference-name,
.conference-attendees {
    color: #212529;
}

.conference-date,
.conference-name,
.conference-attendees {
    font-size: 0.875rem;
    line-height: 1;
}

.conference-title,
.conference-name,
.conference-date,
.conference-attendees {
    margin-bottom: 4px;
}

.fa-beat {
    -webkit-animation: fa-beat 1s infinite linear;
    animation: fa-beat 1s infinite linear;
}

@-webkit-keyframes fa-beat {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@keyframes fa-beat {
    0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
    50% {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    100% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@media (min-width: 1200px) {
    .dashboard-conference-widget {
        max-width: 300px;
        margin-left: auto;
    }
}
</style>
